<template>
  <div class="box">
      <div class="logo">
        <span><img src="../../assets/images/user/touxiang.svg"/></span>
        <!-- <h4>会员服务系统</h4> -->
      </div>
      <div class="content">
        <z-login></z-login>
      </div>
  </div>
</template>

<script>
import zLogin from "./login";
export default {
  data() {
    return {
      statues: 1
    };
  },
  components: {
    zLogin,
  },
  methods: {}
};
</script>

<style lang="less" scoped>
  .logo {
    text-align: center;
    font-size: 18px;
    margin-top: 21%;
    color: #228ccd;
    span{ width:80px; height: 80px; display: block; margin: 0 auto; margin-bottom: 20px;}
    img {
      display: block;
      width:100%;
      margin: 0 auto;
    }
  
  .btn-box {
    display: flex;
    margin-top: 46px;
    justify-content: space-evenly;
    color: #ffffff;
    span{font-size: 16px !important;}
    div {
      display: flex;
      width: 50%;
      text-align: center;
      justify-content: center;
      span {
        &.active::after {
          display: block;
          content: "";
          height: 3px;
          background: #ffffff;
          border-radius: 30px;
          margin-top: 10px;
        }
      }
    }
  }
}
.content {
  padding: 0 25px;
}
</style>
